import { format } from "date-fns";
import { parseISOWithoutTime } from "helpers/date-helpers";

const sizeCopyFormatter = size => {
  switch (size) {
    case "S":
      return "a size Small";
    case "M":
      return "a size Medium";
    case "L":
      return "a size Large";
    default:
      return `a size ${size}`;
  }
};

const timeIntervalCopyFormatter = dateString => {
  const date = parseISOWithoutTime(dateString);

  const rentalMonth = format(date, "MMMM");
  const rentalYear = format(date, "yyyy");

  const thisYear = format(new Date(), "yyyy");

  if (rentalYear === thisYear) {
    return rentalMonth;
  }

  return `${rentalMonth} ${rentalYear}`;
};

const findWithPrefix = (list, prefix) => list.find(item => item.includes(prefix));

const fitExperienceCopyFormatter = feedbacks => {
  const feedbackStrings = feedbacks.map(response => {
    return response.feedback;
  });

  if (findWithPrefix(feedbackStrings, "BIG_")) {
    return "found it was too big";
  } else if (findWithPrefix(feedbackStrings, "SMALL_")) {
    return "found it was too small";
  } else if (findWithPrefix(feedbackStrings, "LONG_")) {
    return "found it too long";
  } else if (findWithPrefix(feedbackStrings, "SHORT_")) {
    return "found it too short";
  } else if (feedbackStrings.includes("LIKED_IT")) {
    return "liked it";
  } else if (feedbackStrings.includes("LOVED_IT")) {
    return "loved it";
  } else if (feedbackStrings.includes("JUST_OK")) {
    return "found it just ok";
  }
};

const PreviouslyRentedSize = surveys => {
  // if there are no recorded happiness surveys for that style hide PreviouslyRentedSize
  if (!surveys || surveys.length === 0) {
    return null;
  }

  const mostRecentSurvey = surveys?.[0];

  if (!mostRecentSurvey) {
    return null;
  }

  const { created, size, surveyFeedbacks } = mostRecentSurvey;
  if (!created || !size) {
    return null;
  }

  const sizeCopy = sizeCopyFormatter(size);
  const timeIntervalCopy = timeIntervalCopyFormatter(created);
  const fitExperience = surveyFeedbacks ? fitExperienceCopyFormatter(surveyFeedbacks) : "";
  const fitExperienceCopy = fitExperience ? `and ${fitExperience}` : "";

  return { size, copy: `You rented ${sizeCopy} in ${timeIntervalCopy} ${fitExperienceCopy}` };
};

export default PreviouslyRentedSize;
